import { createStore } from "redux";

import createReducers, { initialState } from "./reducers";

import asyncReducers from "data/async-reducers";
import composedMiddleware from "data/middleware";

const setInitialState = (props) => {
  const { entity, assets, sections, user } = props;

  const initial = {
    entity: initialState.entity.merge(entity),
    assets: initialState.assets.merge(assets),
    sections: initialState.sections.merge(sections),
    user: initialState.user.merge(user),
  };

  return initial;
};

export default (props) => {
  const initialState = setInitialState(props);
  const store = createStore(createReducers(), initialState, composedMiddleware());

  const enhancedStore = asyncReducers(store, createReducers);

  return enhancedStore;
};
